import React, { useState } from "react";
import { API_BASE_URL } from "../../config.tsx";
import apiFetch from "../helpers/requests";
import "../../styles/admin.css";
import { useTranslation } from "react-i18next";

const ConfirmDeleteHospitalModal = ({
  setShowConfirmDeleteHospitalModal,
  hospitalId,
  hospitalName,
  hospitalCountryCode,
  handleDeleteHospitalSubmit,
}) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const deleteHospital = async (hospitalId: string | null) => {
    try {
      const data = await apiFetch(`/deleteGroup`, {
        method: "POST",
        body: JSON.stringify({ groupId: hospitalId }), // Send as groupId for backend compatibility
      });
      return data;
    } catch (error) {
      console.error("Error delete hospital:", error);
      throw new Error("An error occurred while delete hospital");
    }
  };

  const handleDeleteHospitalClick = async (hospitalId: string | null) => {
    setIsLoading(true);
    try {
      await deleteHospital(hospitalId);
      setShowConfirmDeleteHospitalModal(false);
      handleDeleteHospitalSubmit();
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_delete_hospital")}
        </div>
        <label style={{ lineHeight: "1", marginTop: "2vh" }}>
          {t("This_is_irreversible_action.")}
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5vh",
            maxHeight: "1%",
          }}
        >
          <img
            src="/images/Icon_Hospital.png"
            style={{
              width: "5vh",
              minWidth: "25px",
              marginRight: "1vh",
            }}
          />
          <div className="userDataWrapper">
            {hospitalName} | {t("country_" + hospitalCountryCode)}
          </div>
        </div>

        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            disabled={isLoading}
            onClick={() => setShowConfirmDeleteHospitalModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            disabled={isLoading}
            onClick={() => handleDeleteHospitalClick(hospitalId)}
          >
            {isLoading ? t("Loading...") : t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteHospitalModal;
